module.exports = __webpack_public_path__ + "img/m-banner.4ea57b43.png";